import { ChevronDown, Phone } from "lucide-react";

export const tempKey = (n) => (["calda", "media", "fredda"].includes(n.temperatura) ? n.temperatura : "senza");

const BOX = [
  ["calda", "🔥", "Notizie calde", "bg-red-50 border-red-200 text-red-700", "ring-red-400"],
  ["media", "🟠", "Notizie medie", "bg-orange-50 border-orange-200 text-orange-700", "ring-orange-400"],
  ["fredda", "❄️", "Notizie fredde", "bg-sky-50 border-sky-200 text-sky-700", "ring-sky-400"],
  ["senza", "•", "Senza temperatura", "bg-slate-50 border-slate-200 text-slate-600", "ring-slate-400"],
];

const conta = (list) => list.reduce((a, n) => { const k = tempKey(n); a[k] = (a[k] || 0) + 1; return a; }, {});

function AgenteMenu({ agenti, agente, setAgente }) {
  return (
    <div className="flex items-center gap-2 mb-3">
      <label className="text-[11px] font-semibold uppercase tracking-wide text-[var(--muted)]">Agente</label>
      <select data-testid="notizie-agente-select" value={agente} onChange={(e) => setAgente(e.target.value)}
        className="px-3 py-2 rounded-xl bg-white border border-[var(--border)] text-sm font-semibold focus:border-[#FC82ED] outline-none">
        <option value="all">Tutti</option>
        {agenti.map(([id, nome]) => <option key={id} value={id}>{nome}</option>)}
      </select>
    </div>
  );
}

function Riepilogo({ items, agenti, apri }) {
  const per = agenti.map(([id, nome]) => [id, nome, conta(items.filter((n) => n.owner_agent_id === id))]);
  const senza = per.some(([, , c]) => c.senza);
  const cols = senza ? ["calda", "media", "fredda", "senza"] : ["calda", "media", "fredda"];
  const Num = ({ id, k, v }) => (
    <button data-testid={`riepilogo-${k}-${id}`} disabled={!v} onClick={() => apri(id, k)}
      className="mono font-bold px-2 py-0.5 rounded-lg hover:bg-[#FC82ED]/15 disabled:opacity-40 disabled:hover:bg-transparent">{v || 0}</button>
  );
  return (
    <div className="card-immo p-0 overflow-x-auto mt-3" data-testid="notizie-riepilogo-agenti">
      <table className="w-full text-xs sm:text-sm">
        <thead className="bg-[#F7F7F8] text-[10px] uppercase tracking-wider text-[var(--muted)]">
          <tr><th className="p-2.5 text-left">Agente</th><th className="p-2.5">Calde</th><th className="p-2.5">Medie</th><th className="p-2.5">Fredde</th>{senza && <th className="p-2.5">Senza temp.</th>}<th className="p-2.5">Totale</th></tr>
        </thead>
        <tbody className="divide-y divide-[var(--border)]">
          {per.map(([id, nome, c]) => (
            <tr key={id} data-testid={`riepilogo-row-${id}`}>
              <td className="p-2.5 font-semibold">{nome}</td>
              {cols.map((k) => <td key={k} className="p-2.5 text-center"><Num id={id} k={k} v={c[k]} /></td>)}
              <td className="p-2.5 text-center"><Num id={id} k="tutte" v={Object.values(c).reduce((a, b) => a + b, 0)} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function NotizieTemperature({ items, scoped, open, setOpen, agente, setAgente, agenti, showMenu, showTable, slotRef, richiamare }) {
  const c = conta(items);
  const apri = (id, k) => { setAgente(id); setOpen(k); setTimeout(() => document.getElementById("notizie-elenco")?.scrollIntoView({ behavior: "smooth", block: "start" }), 50); };
  return (
    <div className="mb-4" data-testid="notizie-temperature">
      {showMenu && <AgenteMenu agenti={agenti} agente={agente} setAgente={setAgente} />}
      <div className={`grid gap-3 ${c.senza ? "grid-cols-2 lg:grid-cols-5" : "grid-cols-2 lg:grid-cols-4"}`}>
        {BOX.filter(([k]) => k !== "senza" || c.senza).map(([k, ico, label, cls, ring]) => (
          <button key={k} data-testid={`temp-box-${k}`} aria-expanded={open === k} onClick={() => setOpen(open === k ? null : k)}
            className={`rounded-2xl border-2 p-4 sm:p-5 text-left transition-transform hover:-translate-y-0.5 ${cls} ${open === k ? `ring-2 ${ring}` : ""}`}>
            <div className="flex items-center gap-2 text-sm sm:text-base font-bold"><span className="text-xl">{ico}</span> {label}
              <ChevronDown size={18} className={`ml-auto transition-transform ${open === k ? "rotate-180" : ""}`} /></div>
            <div className="mono text-3xl sm:text-4xl font-extrabold mt-2 text-[#111111]" data-testid={`temp-count-${k}`}>{c[k] || 0}</div>
          </button>
        ))}
        {richiamare !== undefined && (
          <button data-testid="temp-box-richiamare" aria-expanded={open === "richiamare"} onClick={() => setOpen(open === "richiamare" ? null : "richiamare")}
            className={`rounded-2xl border-2 p-4 sm:p-5 text-left transition-transform hover:-translate-y-0.5 bg-[#2B2B2B] border-[#2B2B2B] text-white ${open === "richiamare" ? "ring-2 ring-[#FC82ED]" : ""}`}>
            <div className="flex items-center gap-2 text-sm sm:text-base font-bold"><Phone size={18} className="text-[#FC82ED]" /> Da richiamare
              <ChevronDown size={18} className={`ml-auto transition-transform ${open === "richiamare" ? "rotate-180" : ""}`} /></div>
            <div className="mono text-3xl sm:text-4xl font-extrabold mt-2" data-testid="temp-count-richiamare">{richiamare}</div>
            <div className="text-[11px] text-white/60">da oltre 90 giorni</div>
          </button>)}
      </div>
      {slotRef && <div ref={slotRef} data-testid="notizie-carosello" className="mt-3 empty:hidden" />}
      {showTable && <Riepilogo items={scoped} agenti={agente === "all" ? agenti : agenti.filter(([id]) => id === agente)} apri={apri} />}
    </div>
  );
}
